import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {greyishBlue600} from "assets/jss/main";

import {formatDateTime} from "views/personalShopper/components/formatters";

import SideCard from "./SideCard";

ProfileCard.propTypes = {
    profile: PropTypes.shape({
        summary: PropTypes.string,
        updatedAt: PropTypes.string,
    }),
};

/**
 * The customer profile as the assistant rewrote it after the last session: who they are,
 * who they buy for, tastes, sizes, what they asked and liked.
 */
function ProfileCard({profile}) {
    return (
        <SideCard titleId="personalShopper.sheet.profile">
            {profile?.summary ? (
                <>
                    <div style={{whiteSpace: "pre-wrap", fontSize: "14px"}}>{profile.summary}</div>
                    <div style={{color: greyishBlue600, fontSize: "12px", marginTop: "8px"}}>
                        <FormattedMessage id="personalShopper.profile.updatedAt" values={{date: formatDateTime(profile.updatedAt)}} />
                    </div>
                </>
            ) : (
                <div style={{color: greyishBlue600, fontSize: "13px"}}><FormattedMessage id="personalShopper.profile.empty" /></div>
            )}
        </SideCard>
    );
}

export default ProfileCard;
